import { makeAutoObservable } from "mobx";

const MAX_LOG_LINES_PER_SERVER = 1000;

export default class LogStore {
    constructor() {
        this._log = {};

        makeAutoObservable(this);
    }

    setLog(storage) {
        const { log, data } = storage || {};

        if (typeof log === "undefined" || log === null || !Array.isArray(data)) {
            console.warn("Некорректные данные для setLog:", storage);
            return;
        }

        const current = this._log[log] || { log, data: [] };
        const nextData = current.data.concat(data).slice(-MAX_LOG_LINES_PER_SERVER);

        this._log = {
            ...this._log,
            [log]: {
                log,
                data: nextData,
            },
        };
    }

    getStorageByLogId(logId) {
        return this._log[logId] || { log: logId, data: [] };
    }

    reset() {
        this._log = {};
    }

    get log() {
        return this._log;
    }
}
